<template>
<div class="div_footer" :style="!isFooterShow ? 'visibility: hidden;' : ''">
    <p class="Copyright-2018-Nuw"><a class="copyright_a">Copyright © 2018 Nuwa Robotic. All rights reserved. </a></p>
    <p class="Login-Page_Link">
        <a :href="terms">Terms of Use</a>
        <a :href="pricacy">Pricacy Policy</a>
        <a>System Status</a>
    </p>
    <div style="display:none;">{{switchLanguage}}</div>
</div>
</template>

<script>
export default {
    data () {
        return {
            terms: 'https://user-privacy.nuwarobotics.cn/zh-tw/terms.html',
            pricacy: 'https://user-privacy.nuwarobotics.cn/zh-tw/privacy.html',
            isFooterShow: null
        }
    },
    computed: {
        // token () {
        //     console.log('token')
        //     this.tokenLocalStorage = this.$store.state.token
        //     return
        // },
        switchLanguage () {
            let lang = this.$store.state.switchLanguage
            if (lang === 'en') {
                this.terms = 'https://user-privacy.nuwarobotics.cn/zh-tw/terms.html'
                this.pricacy = 'https://user-privacy.nuwarobotics.cn/zh-tw/privacy.html'
            } else if (lang === 'zh-TW') {
                this.terms = 'https://user-privacy.nuwarobotics.cn/zh-tw/terms.html'
                this.pricacy = 'https://user-privacy.nuwarobotics.cn/zh-tw/privacy.html'
            } else {
                this.terms = 'https://user-privacy.nuwarobotics.cn/zh-cn/terms.html'
                this.pricacy = 'https://user-privacy.nuwarobotics.cn/zh-cn/privacy.html'
            }
        }
    },
    mounted () {
        this.isFooterShow = this.$store.isFooterShow
    }
}
</script>

<style scoped>
    .div_footer{
        font-family: sans-serif;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 0.8px;
    }
    .copyright_a {
        color: #333333;
    }
    .Login-Page_Link a:not(:last-child) {
        border-right: 1px solid;
    }
    .Login-Page_Link a {
        padding: 0 18px;
        color: #333333;
    }
    p {
        margin: 10px 0px;
    }
    .Copyright-2018-Nuw{
        margin-left: 24px;
    }
</style>
